import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ReactPixel from 'react-facebook-pixel';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import WhatWeDo from './components/WhatWeDo';
import OurWork from './components/OurWork';
import Project from './components/Project';
import Contact from './components/Contact';
import Team from './components/Team';
import NotFound from './components/NotFound';

const advancedMatching = {
  em: ''
  // em: 'some@email.com'
}; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
const options = {
  autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
  debug: true, // enable logs
  // debug: false, // enable logs
};
ReactPixel.init(303159614893810, advancedMatching, options);
ReactPixel.pageView(); // For tracking page view

const App = () => {
  return (
    <BrowserRouter>
      <div>
        <Header />
        <div className="route-container">
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/index2.html' element={<Home />} />
            <Route path='/what-we-do' element={<WhatWeDo />} />
            <Route path='/our-work' element={<OurWork />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='/our-work/:slug' element={<Project />} />
            <Route path='/team' element={<Team />} />
            <Route path='*' element={<NotFound />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </BrowserRouter>
  )
}

export default App;